import moment from "moment";
export const api_prefix = "api/v1";

export const requestStatus = {
  loading: "loading",
  success: "success",
  error: "error",
  error_connection: "error_connection",
  logout: "logout",
};

export function isTodayBeforeTargetDate(end_date, trial_data) {
  const today = moment().startOf("day");

  if (trial_data && today.isSameOrBefore(moment(trial_data, "YYYY-MM-DD"))) {
    return true;
  }

  if (end_date) {
    return today.isSameOrBefore(moment(end_date, "YYYY-MM-DD"));
  }

  return false;
}

export function formatUserData(data) {
  // let newData = {
  //   ...data,
  //   subscription: {
  //     id: 96,
  //     status: "success",
  //     end_date: "2026-05-22T00:00:00.000Z",
  //     trial_end_date: "2026-05-22T00:00:00.000Z",
  //     tariff: {
  //       id: 1,
  //       name: "Tariff1",
  //       description: "Test 1",
  //       price: "12.99",
  //       days: 7,
  //     },
  //   },
  // };
  // return {
  //   ...newData,
  //   is_temporary: true,
  //   has_free_swaps: Boolean(
  //     newData.total_predictions !== undefined &&
  //       newData.total_predictions !== null &&
  //       +newData.total_predictions <= 10
  //   ),
  //   is_active_premium:
  //     newData.subscription &&
  //     (newData.subscription.end_date || newData.subscription.trial_end_date)
  //       ? isTodayBeforeTargetDate(
  //           newData.subscription.end_date,
  //           newData.subscription.trial_end_date
  //         )
  //       : false,
  // };

  return {
    ...data,
    is_temporary: data.is_temp,
    // has_free_swaps: Boolean(
    //   data.total_predictions !== undefined &&
    //     data.total_predictions !== null &&
    //     +data.total_predictions <= 10
    // ),
    is_active_premium:
      data.subscription &&
      (data.subscription.end_date || data.subscription.trial_end_date)
        ? isTodayBeforeTargetDate(
            data.subscription.end_date,
            data.subscription.trial_end_date
          )
        : false,
  };
}

export const renderDate = (date) => {
  return moment(date).format("DD.MM.YYYY");
};
